/** Query keys must match garaaz-distributor `OrderListNew/constants` URL_SEARCH_PARAMS */
const SID_QUERY = "sid";
const MODE_QUERY = "mode";

function encodeSupplierIdForQuery(supplierId: string): string {
  try {
    return btoa(supplierId);
  } catch {
    return "";
  }
}

/**
 * Opens the supplier web app on a specific order in edit mode, with `sid`
 * so the app can align the session (grazeon proxy) to that supplier.
 */
export function buildSupplierWebOrderEditUrl(
  baseUrl: string,
  orderNo: string,
  supplierId: string
): string | null {
  const trimmedBase = baseUrl?.replace(/\/+$/, "");
  if (!trimmedBase || !orderNo || !supplierId) return null;
  const sid = encodeSupplierIdForQuery(supplierId);
  if (!sid) return null;
  const params = new URLSearchParams();
  params.set(SID_QUERY, sid);
  params.set(MODE_QUERY, "edit");
  return `${trimmedBase}/orders/${encodeURIComponent(orderNo)}?${params.toString()}`;
}

export function getSupplierWebAppBaseUrl(): string {
  return (process.env.REACT_APP_SUPPLIER_WEB_APP_URL || "").trim();
}
